module.exports = __webpack_public_path__ + "assets/img/Deauville_009.d066227b.svg";